import yup, {
  stringRequired,
  addressValidation,
  minDateTodayRequired,
  phoneNumber,
} from "common/libs/yup";

export const brokerProfileValidation = yup.object({
  brokerLicenseNum: stringRequired,
  brokerLicenseJurisdiction: stringRequired,
  brokerLicenseExpiryDate: minDateTodayRequired,
  brokerageName: stringRequired,
  brokerageTaxNum: stringRequired,
  brokerageAddress: addressValidation,
  brokeragePhone: phoneNumber.required(),
});

export type BrokerProfileSchema = yup.InferType<typeof brokerProfileValidation>;
